import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { colorPalette, fonts } from '../styles/styleGuide';
import withApiData from '../services/withApiData';
import { connect } from 'react-redux';
import { performApiRequest, getResultData, getApiDataRequest, clearCache } from '../redux/apiData';
import { openModal } from '../redux/modal';
import FlyOutMenu from './FlyOutMenu';
import Caret from './shared/icons/Caret';
import LoginIcon from './shared/icons/Logout';
import UserAvatar from './UserAvatar';
import LockIcon from './shared/icons/Key';
import SettingsIcon from './shared/icons/Profile';
import CalendarIcon from './shared/icons/Actions';
import MailIcon from './shared/icons/Message';
import FolderIcon from './shared/icons/Documents';
import HouseIcon from './shared/icons/HouseBase';
import NotificationsCounter from './NotificationsCounter';
import getLinkFromPageObject from '../services/getLinkFromPageObject';
import get from 'lodash.get';
import countNotifications from '../services/countNotifications';
import withMatch from '@/hocs/withMatch';
var connectApiData = withApiData({
  profile: 'getProfile'
}, function (ownProps) {
  return {
    profile: {
      projectSlug: ownProps.projectSlug
    }
  };
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    notifications: getResultData(state.apiData, 'getNotifications', {
      projectSlug: ownProps.projectSlug
    }),
    activationPossible: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: ownProps.projectSlug,
      env: 'closed'
    }), 'activationPossible', false),
    logoutUserRequest: getApiDataRequest(state.apiData, 'logoutUser')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getNotifications: function getNotifications() {
      dispatch(performApiRequest('getNotifications', {
        projectSlug: String(ownProps.projectSlug)
      }));
    },
    openActivationModal: function openActivationModal(activationType) {
      dispatch(openModal(colorPalette.lightOrange, {
        type: 'activation',
        componentProps: {}
      }));
    },
    onLogout: function onLogout() {
      var _ownProps$router;
      dispatch(performApiRequest('logoutUser'));
      dispatch(clearCache());
      (_ownProps$router = ownProps.router) === null || _ownProps$router === void 0 || _ownProps$router.push("/".concat(ownProps.projectSlug, "/closed"));
    }
  };
};
var LoginBarClosedEnv = /*#__PURE__*/function (_Component) {
  function LoginBarClosedEnv() {
    var _this;
    _classCallCheck(this, LoginBarClosedEnv);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LoginBarClosedEnv, [].concat(args));
    _defineProperty(_this, "menuOptions", new Map());
    _defineProperty(_this, "state", {
      hover: 'none'
    });
    _defineProperty(_this, "hoverIn", function (type) {
      if (!type) return;
      _this.setState({
        hover: type
      }, function () {
        if (_this.hoverTimeout !== 0) {
          clearTimeout(_this.hoverTimeout);
        }
      });
    });
    _defineProperty(_this, "hoverOut", function () {
      clearTimeout(_this.hoverTimeout);
      _this.hoverTimeout = setTimeout(function () {
        _this.setState({
          hover: 'none'
        });
      }, 150);
    });
    return _this;
  }
  _inherits(LoginBarClosedEnv, _Component);
  return _createClass(LoginBarClosedEnv, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
        phase = _this$props.phase,
        logoutUserRequest = _this$props.logoutUserRequest,
        getNotifications = _this$props.getNotifications;
      if ((phase === 'cj2' || phase === 'cj3') && !logoutUserRequest) {
        getNotifications();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.hoverTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        profile = _this$props2.profile,
        notifications = _this$props2.notifications,
        phase = _this$props2.phase,
        projectSlug = _this$props2.projectSlug,
        onLogout = _this$props2.onLogout,
        openActivationModal = _this$props2.openActivationModal,
        activationPossible = _this$props2.activationPossible;
      var name = get(profile, 'data.customer.customerName', profile && profile.data && profile.data.name);
      var imageUrl = get(profile, 'data.customer.customerImage', profile && profile.data && profile.data.image);
      var notificationsTotal = notifications ? countNotifications(notifications) : 0;
      var itemsCJ1 = [{
        name: 'profile',
        label: name,
        phase: ['cj1', 'cj2', 'cj3'],
        icon: __jsx(UserAvatar, {
          imageUrl: imageUrl,
          phase: phase,
          size: "xsmall",
          mode: "bg",
          name: name,
          "data-id": "components_LoginBarClosedEnv_UserAvatar"
        }),
        flyoutMenuOptions: [{
          name: 'profile',
          type: 'link',
          label: 'Profiel',
          link: "/".concat(projectSlug, "/closed/profiel"),
          icon: __jsx(SettingsIcon, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_SettingsIcon"
          })
        }, {
          name: 'logout',
          type: 'button',
          label: 'Uitloggen',
          icon: __jsx(LoginIcon, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_LoginIcon"
          }),
          onClick: onLogout
        }, {
          name: 'activeLink',
          type: 'button',
          label: 'Activatiecode invoeren',
          icon: __jsx(LockIcon, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_LockIcon"
          }),
          onClick: openActivationModal,
          disable: !activationPossible
        }]
      }];
      var itemsCJ2 = notifications ? [{
        name: 'notifications',
        label: 'Notificaties',
        phase: ['cj2', 'cj3'],
        icon: __jsx(NotificationsCounter, {
          notificationsCount: notificationsTotal,
          "data-id": "components_LoginBarClosedEnv_NotificationsCounter"
        }),
        flyoutMenuOptions: [notifications.messages && {
          name: 'messages',
          type: 'link',
          label: 'Ongelezen berichten',
          link: "/".concat(getLinkFromPageObject(notifications.messages.link)),
          icon: __jsx(MailIcon, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_MailIcon"
          }),
          unreadCount: notifications.messages ? notifications.messages.unreadCount : 0
        }, notifications.documents && {
          name: 'documents',
          type: 'link',
          label: 'Nieuwe documenten',
          link: "/".concat(getLinkFromPageObject(notifications.documents.link)),
          icon: __jsx(FolderIcon, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_FolderIcon"
          }),
          unreadCount: notifications.documents ? notifications.documents.unreadCount : 0
        }, notifications.actions && {
          name: 'actions',
          type: 'link',
          label: 'Acties in planning',
          link: "/".concat(getLinkFromPageObject(notifications.actions.link)),
          icon: __jsx(CalendarIcon, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_CalendarIcon"
          }),
          unreadCount: notifications.actions ? notifications.actions.unreadCount : 0
        }, notifications.newOptions && {
          name: 'options',
          type: 'link',
          label: 'Nieuwe opties',
          link: "/".concat(getLinkFromPageObject(notifications.newOptions.link)),
          icon: __jsx(HouseIcon, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_HouseIcon"
          }),
          unreadCount: notifications.newOptions ? notifications.newOptions.unreadCount : 0
        }, notifications.ordersToConfirm && {
          name: 'orders',
          type: 'link',
          label: 'Orders ter bevestiging',
          link: "/".concat(getLinkFromPageObject(notifications.ordersToConfirm.link)),
          icon: __jsx(HouseIcon, {
            width: 18,
            height: 18,
            "data-id": "components_LoginBarClosedEnv_HouseIcon_9"
          }),
          unreadCount: notifications.ordersToConfirm ? notifications.ordersToConfirm.unreadCount : 0
        }]
      }] : [];
      var items = notifications ? itemsCJ1.concat(itemsCJ2) : itemsCJ1;
      return __jsx(Container, {
        "data-id": "components_LoginBarClosedEnv_Container"
      }, items.map(function (item, index) {
        return item.phase.includes(phase) ? __jsx(ItemContainer, {
          key: index,
          onMouseOver: function onMouseOver() {
            return _this2.hoverIn(item.name);
          },
          onMouseLeave: _this2.hoverOut,
          ref: function ref(item) {
            return _this2.menuOptions.set(index, item);
          },
          "data-id": "components_LoginBarClosedEnv_ItemContainer"
        }, __jsx(HoverButton, {
          "data-e2e-header-profilebar-button": item.name,
          "data-id": "components_LoginBarClosedEnv_HoverButton"
        }, __jsx(IconWrapper, {
          "data-id": "components_LoginBarClosedEnv_IconWrapper"
        }, item.icon), item.label, __jsx(Caret, {
          direction: "down",
          color: colorPalette.lightBeige,
          width: 10,
          height: 6,
          "data-id": "components_LoginBarClosedEnv_Caret"
        })), __jsx(FlyOutMenu, {
          visible: _this2.state.hover === item.name,
          projectSlug: projectSlug,
          options: item.flyoutMenuOptions,
          target: _this2.menuOptions.get(index),
          position: "bottom",
          "data-id": "components_LoginBarClosedEnv_FlyOutMenu"
        })) : null;
      }));
    }
  }]);
}(Component);
export default withMatch(connectApiData(connect(mapStateToProps, mapDispatchToProps)(LoginBarClosedEnv)));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"])));
var ItemContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  line-height: 24rem;\n  margin-left: 40rem;\n"])), colorPalette.headerGrey, fonts.primary);
var HoverButton = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  > svg {\n    margin-left: 8rem;\n  }\n"])));
var IconWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: 10rem;\n"])));